import React, { Component } from 'react'

interface iProps {
    showType: string
}

export default class fileTypePopover extends Component<iProps> {
    render() {
        let {showType} = this.props
        return (
            <>
                {
                    showType === 'VIDEO' &&
                    <div className="type_list">
                        <div className="type_title">视频文件格式包括：</div>
                        <div className="type_item">mp4/flv/avi/mov/mkv/m4v/ts</div>
                    </div>
                }
                {
                    showType === 'AUDIO' &&
                    <div className="type_list">
                        <div className="type_title">音频文件格式包括：</div>
                        <div className="type_item">mp3/flac/m4a/ogg</div>
                    </div>
                }
                {
                    showType === 'DOCUMENT' &&
                    <div className="type_list">
                        <div className="type_title">文件格式包括：</div>
                        <div className="type_item">文档类：ppt/pptx/pdf/doc/docx/xls/xlsx/txt</div>
                        <div className="type_item">图片类：jpg/png/jpeg/gif</div>
                        <div className="type_item">压缩包类：zip/rar/tar</div>
                    </div>
                }
                {
                    showType === 'RESOURCE' &&
                    <div className="type_list">
                        <div className="type_title">视频文件格式包括：</div>
                        <div className="type_item">mp4/flv/avi/mov/mkv/m4v/ts</div>

                        <div className="type_title" style={{marginTop: 10}}>音频文件格式包括：</div>
                        <div className="type_item">mp3/flac/m4a/ogg</div>
                        
                        <div className="type_title" style={{marginTop: 10}}>文件格式包括：</div>
                        <div className="type_item">文档类：ppt/pptx/pdf/doc/docx/xls/xlsx/txt</div>
                        <div className="type_item">图片类：jpg/png/jpeg/gif</div>
                        <div className="type_item">压缩包类：zip/rar/tar</div>
                    </div>
                }
            </>
        )
    }
}
